import billingReportConfigData from '../utils/billingReportConfigData'
import {baseReportDownloadMixin} from "./base-report-download-mixin"

export default {
  mixins: [baseReportDownloadMixin],
  computed: {
    /**
     * @override
     */
    reportConfigData () {
      return billingReportConfigData
    }
  },
  methods: {
    /**
     * @override
     */
    transformFieldsBeforeSend () {
      this.transformed = Object.assign({}, this.fields)
      this.transformed.fiz = this.fields.fiz ? 1 : 0
      this.transformed.legal = +this.fields.legal ? 1 : 0
    }
  },
  asyncData () {
    return Promise.resolve()
  }
}
